import type { AssetListItem } from '~/data/AssetListItem/AssetListItem';
import type ErrorRecord from '~/data/ErrorRecord';
import type {
  AssetBrandGroupsOtherType,
  AssetCategoryType,
  AssetModelType,
  AssetSubcategoryType,
  HvaBrandType,
  OtherBrandModelType,
} from '~/ducks/asset-types/data/types';
import type ModalStep from './modal-step';

export const defaultState: Fields = {
  isAdding: false,
  isAdded: false,
  modalIsOpen: false,
  assetType: '',
  category: undefined,
  subcategory: undefined,
  brandGroup: undefined,
  model: undefined,
  otherBrandModel: undefined,
  step: undefined,
  addedMachine: undefined,
  error: undefined,
};

export interface Fields {
  isAdding: boolean;
  isAdded: boolean;
  modalIsOpen: boolean;
  assetType: string;
  category?: AssetCategoryType;
  subcategory?: AssetSubcategoryType;
  brandGroup?: null | HvaBrandType | AssetBrandGroupsOtherType;
  model?: AssetModelType;
  otherBrandModel?: OtherBrandModelType | null;
  step?: ModalStep;
  addedMachine?: AssetListItem;
  error?: ErrorRecord;
}
